import "./aPixi";
export var PIXI = window["PIXI"];
